/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
    DocumentToJSONTyped,
} from './Document';

/**
 * 
 * @export
 * @interface UpdateDocumentResponse
 */
export interface UpdateDocumentResponse {
    /**
     * 
     * @type {Document}
     * @memberof UpdateDocumentResponse
     */
    data: Document;
}

/**
 * Check if a given object implements the UpdateDocumentResponse interface.
 */
export function instanceOfUpdateDocumentResponse(value: object): value is UpdateDocumentResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateDocumentResponseFromJSON(json: any): UpdateDocumentResponse {
    return UpdateDocumentResponseFromJSONTyped(json, false);
}

export function UpdateDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDocumentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': DocumentFromJSON(json['data']),
    };
}

  export function UpdateDocumentResponseToJSON(json: any): UpdateDocumentResponse {
      return UpdateDocumentResponseToJSONTyped(json, false);
  }

  export function UpdateDocumentResponseToJSONTyped(value?: UpdateDocumentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': DocumentToJSON(value['data']),
    };
}

